var exports = {
  "kL": "xaf9ae18d--480857--container",
  "Wf": "xaf9ae18d--480857--rounded",
  "mc": "xaf9ae18d--480857--middle",
  "as": "xaf9ae18d--480857--large",
  "n2": "xaf9ae18d--480857--extra-large",
};

module.exports = exports;
